/*
 *
 * GroupsInfoPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 09-May-2025
*/

import GroupsInfoPopup from './GroupsInfoPopupContainer'

export default GroupsInfoPopup
